module.exports = __webpack_public_path__ + "img/icon-16-drop-down-hover.bad58dde.svg";